// This is a very odd fix, as there's no classes or ID's on the zendesk side of things
// To get around this we're targetting the elements by things like their titles. This is hacky, but the only real option we have
document.addEventListener("DOMContentLoaded", () => {
    // Primary config options for the fix
    const maxExecutionTime: number = 10000;
    const checkFrequency: number = 500;
    const loopElementTarget: string = "#loop-onstore";
    const zendeskButtonElementTarget: string =
        'iframe[title="Button to launch messaging window, conversation in progress"], iframe[title="Button to launch messaging window"]';
    const zendeskMessageElementTarget: string =
        'div:has( > div > iframe[title="Message from company"])';
    const zendeskWindowElementTarget: string =
        'div:has( > iframe[title="Messaging window"])';

    let checksPerformed: number = 0;

    const checkInterval: NodeJS.Timer = setInterval(() => {
        checksPerformed++;

        const loopReturnsElement: HTMLElement =
            document.querySelector(loopElementTarget);

        if (loopReturnsElement) {
            const additionalStylesElement: HTMLStyleElement =
                document.createElement("style");

            // Add updated properties for the Zendesk Button Element to the new styles element
            additionalStylesElement.innerHTML += `
        ${zendeskButtonElementTarget},
        ${zendeskMessageElementTarget},
        ${zendeskWindowElementTarget} {
          display: none !important;
        }
      `;

            document.head.appendChild(additionalStylesElement);

            clearInterval(checkInterval);
        }

        if (checksPerformed * checkFrequency >= maxExecutionTime)
            clearInterval(checkInterval);
    }, checkFrequency);
});
